import { store } from 'src/store'
import Dialog from 'src/helpers/dialog'
import Bus from 'src/helpers/bus'

export default function (newSetting) {
  let needsReload = false
  const currSetting = store.getters.getMaintenance
  const currStatus = currSetting ? currSetting.status : 'OFF'

  switch (newSetting.status) {
    case 'OFF':
      needsReload = currStatus === 'ON'
      break
    case 'PENDING':
      needsReload = currStatus === 'ON'
      if (currStatus === 'OFF') {
        Dialog({
          title: 'Maintenance',
          message: newSetting.pending_message,
          persistent: true
        })
      }
      break
    case 'ON':
      break
  }

  store.commit('setMaintenance', newSetting)

  if (needsReload) {
    Bus.emit('version:refresh')
  }
}
